import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/76259574cc87b5a5d26015f9ccc49848.jpg',
      alt: 'Fachada',
      category: 'Fachada',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Elegant%20apartment%20building%20lobby%20entrance%20hall%20modern%20interior%20design%20marble%20floors%20contemporary%20furniture%20sophisticated%20lighting%20professional%20real%20estate%20photography%20high%20quality&width=600&height=800&seq=atmos-gal-lobby-002&orientation=portrait',
      alt: 'Lobby',
      category: 'Lobby',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20common%20areas%20hallway%20corridor%20contemporary%20interior%20design%20elegant%20finishes%20professional%20lighting%20real%20estate%20photography%20high%20quality&width=800&height=600&seq=atmos-gal-areas-003&orientation=landscape',
      alt: 'Áreas Comuns',
      category: 'Áreas Comuns',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20leisure%20area%20rooftop%20swimming%20pool%20lounge%20space%20contemporary%20design%20city%20view%20professional%20real%20estate%20photography%20sunset%20lighting%20high%20quality&width=600&height=800&seq=atmos-gal-lazer-004&orientation=portrait',
      alt: 'Lazer',
      category: 'Lazer',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20fitness%20center%20gym%20equipment%20contemporary%20interior%20design%20large%20windows%20natural%20lighting%20professional%20real%20estate%20photography%20high%20quality&width=800&height=600&seq=atmos-gal-fitness-005&orientation=landscape',
      alt: 'Fitness',
      category: 'Lazer',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Downtown%20Curitiba%20Brazil%20cityscape%20view%20from%20apartment%20building%20urban%20skyline%20modern%20architecture%20daytime%20clear%20sky%20professional%20real%20estate%20photography%20high%20quality&width=600&height=800&seq=atmos-gal-vista-006&orientation=portrait',
      alt: 'Vista/Entorno',
      category: 'Vista/Entorno',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20coworking%20space%20contemporary%20interior%20design%20desks%20chairs%20natural%20lighting%20professional%20real%20estate%20photography%20high%20quality&width=800&height=600&seq=atmos-gal-cowork-007&orientation=landscape',
      alt: 'Coworking',
      category: 'Áreas Comuns',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20living%20room%20interior%20modern%20furniture%20large%20windows%20city%20view%20contemporary%20design%20professional%20real%20estate%20photography%20natural%20lighting%20high%20quality&width=600&height=800&seq=atmos-gal-living-008&orientation=portrait',
      alt: 'Living Decorado',
      category: 'Áreas Comuns',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20rooftop%20terrace%20lounge%20area%20outdoor%20furniture%20city%20view%20contemporary%20design%20professional%20real%20estate%20photography%20golden%20hour%20lighting%20high%20quality&width=800&height=600&seq=atmos-gal-terraço-009&orientation=landscape',
      alt: 'Terraço',
      category: 'Lazer',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20building%20parking%20garage%20underground%20modern%20design%20organized%20spaces%20good%20lighting%20professional%20real%20estate%20photography%20high%20quality&width=600&height=800&seq=atmos-gal-parking-010&orientation=portrait',
      alt: 'Estacionamento',
      category: 'Áreas Comuns',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20panoramic%20elevator%20glass%20walls%20city%20view%20contemporary%20design%20professional%20real%20estate%20photography%20high%20quality&width=800&height=600&seq=atmos-gal-elevator-011&orientation=landscape',
      alt: 'Elevador Panorâmico',
      category: 'Áreas Comuns',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20building%20night%20view%20illuminated%20facade%20contemporary%20architecture%20urban%20setting%20professional%20real%20estate%20photography%20high%20quality&width=600&height=800&seq=atmos-gal-night-012&orientation=portrait',
      alt: 'Vista Noturna',
      category: 'Fachada',
    },
  ];

  return (
    <>
      <section id="galeria" className="bg-gray-50 py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black mb-4">
              Galeria ATMOS
            </h2>
            <p className="text-gray-600 text-lg">
              Conheça os espaços e diferenciais do empreendimento
            </p>
          </div>

          {/* Masonry Grid */}
          <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
            {images.map((image, index) => (
              <div
                key={index}
                className="break-inside-avoid cursor-pointer group"
                onClick={() => setSelectedImage(image.url)}
              >
                <div className="relative rounded-2xl overflow-hidden bg-white shadow-sm">
                  <div className="w-full" style={{ aspectRatio: image.url.includes('portrait') ? '3/4' : '4/3' }}>
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                    <i className="ri-search-line text-white text-4xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                    <p className="text-white font-medium text-sm">{image.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <div className="mt-12 text-center bg-white rounded-2xl p-6 max-w-3xl mx-auto">
            <p className="text-gray-700 text-base leading-relaxed">
              <i className="ri-information-line mr-2 text-primary"></i>
              <strong>Nota:</strong> Subir fotos oficiais do ATMOS (mídia autorizada pela ATR/Levalo). 
              As imagens atuais são ilustrativas para demonstração do layout.
            </p>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-8 right-8 text-white text-4xl hover:text-gray-300 transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
            aria-label="Fechar"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={selectedImage}
            alt="Imagem ampliada"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
